import script from "./CanvasSizes.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanvasSizes.vue?vue&type=script&setup=true&lang=ts"

import "./CanvasSizes.scss?vue&type=style&index=0&id=fdd60964&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdd60964"]])

export default __exports__